"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); //
// Optional
//

exports.now = function () {
  return Date.now();
};
/** Provide custom color names for interpolation */


exports.colorNames = null;
/** Make all animations instant and skip the frameloop entirely */

exports.skipAnimation = false;
/** Intercept props before they're passed to an animated component */

exports.getComponentProps = function (props) {
  return props;
};
/** Wrap the `style` prop with an animated node */


exports.createAnimatedStyle = null;
/** Wrap the `transform` prop with an animated node */

exports.createAnimatedTransform = null;
exports.requestAnimationFrame = typeof window !== 'undefined' ? window.requestAnimationFrame : function () {
  return -1;
};
exports.cancelAnimationFrame = typeof window !== 'undefined' ? window.cancelAnimationFrame : function () {};

exports.assign = function (globals) {
  var _a;

  return _a = Object.assign({
    now: exports.now,
    frameLoop: exports.frameLoop,
    colorNames: exports.colorNames,
    skipAnimation: exports.skipAnimation,
    defaultElement: exports.defaultElement,
    getComponentProps: exports.getComponentProps,
    applyAnimatedValues: exports.applyAnimatedValues,
    createStringInterpolator: exports.createStringInterpolator,
    createAnimatedInterpolation: exports.createAnimatedInterpolation,
    createAnimatedTransform: exports.createAnimatedTransform,
    createAnimatedStyle: exports.createAnimatedStyle,
    requestAnimationFrame: exports.requestAnimationFrame,
    cancelAnimationFrame: exports.cancelAnimationFrame
  }, pluckDefined(globals)), exports.now = _a.now, exports.frameLoop = _a.frameLoop, exports.colorNames = _a.colorNames, exports.skipAnimation = _a.skipAnimation, exports.defaultElement = _a.defaultElement, exports.getComponentProps = _a.getComponentProps, exports.applyAnimatedValues = _a.applyAnimatedValues, exports.createStringInterpolator = _a.createStringInterpolator, exports.createAnimatedInterpolation = _a.createAnimatedInterpolation, exports.createAnimatedTransform = _a.createAnimatedTransform, exports.createAnimatedStyle = _a.createAnimatedStyle, exports.requestAnimationFrame = _a.requestAnimationFrame, exports.cancelAnimationFrame = _a.cancelAnimationFrame, _a;
}; // Ignore undefined values


function pluckDefined(globals) {
  var defined = {};

  for (var key in globals) {
    if (globals[key] !== void 0) defined[key] = globals[key];
  }

  return defined;
}